import moment from 'moment';
import React from 'react';
import XrCardAv from '../../../components/XrCardAv.tsx';
import XrTextAv from '../../../components/XrTextAv.tsx';
import XrButtonAv from '../../../components/XrButtonAv.tsx';
import XrDataTable from '../../../components/XrDataTable.tsx';
import BootstrapGrid from '../../../components/BootstrapGrid.tsx';
import { useSelector } from 'react-redux';

const FormConfirm = (props) => {
  const authorizedUser = useSelector((state) => state.authentication.authorizedUser);

  return (
    <React.Fragment>
      <XrCardAv>
        <div className="card--title">
          <div className="card--title requestBooking__toolbar">
            <div>
              <XrTextAv tag='h2' variant='title'>
                Konfirmasi Peminjaman
              </XrTextAv>
              <XrTextAv tag='p' variant='description'>
                Mohon periksa kembali bahwa informasi berikut sudah benar.
              </XrTextAv>
            </div>
            <XrButtonAv
              noBlock
              size='large'
              style={{ width: '150px' }}
              caption={`Ubah Identitas`}
              disabled={props.isLoading}
              isLoading={props.isLoading}
              onClick={() => props.setCurrentStep('04-identitas-pemohon')}
            />
          </div>
        </div>
        <div className="card--body">
          <BootstrapGrid>
            <div className='row'>
              <div className='col-md-6'>
                <XrTextAv tag='p' variant='description'>
                  Nama Kegiatan
                </XrTextAv>
                <XrTextAv tag='p' variant='body'>
                  {props.form.description}
                </XrTextAv>

                <br />
                <XrTextAv tag='p' variant='description'>
                  Estimasi Jumlah Peserta
                </XrTextAv>
                <XrTextAv tag='p' variant='body'>
                  {props.form.estimate_participant}
                </XrTextAv>

                <br />
                <XrTextAv tag='p' variant='description'>
                  Tanggal Meminjam
                </XrTextAv>
                <XrTextAv tag='p' variant='body'>
                  {moment(props.form.start_date).format('DD MMMM YYYY')}
                </XrTextAv>

                <br />
                <XrTextAv tag='p' variant='description'>
                  Waktu Kegiatan
                </XrTextAv>
                <XrTextAv tag='p' variant='body'>
                {moment(props.form.start_date).format('HH:MM')} — {moment(props.form.end_date).format('HH:MM')}
                </XrTextAv>

                <br />
                <XrTextAv tag='p' variant='description'>
                  Catatan
                </XrTextAv>
                <XrTextAv tag='p' variant='body'>
                  {props.form.notes || 'Tidak ada catatan'}
                </XrTextAv>
              </div>
              <div className='col-md-6'>
                <XrTextAv tag='p' variant='description'>
                  Nama Pemohon
                </XrTextAv>
                <XrTextAv tag='p' variant='body'>
                  {authorizedUser.name}
                </XrTextAv>

                <br />
                <XrTextAv tag='p' variant='description'>
                  Organisasi Pemohon
                </XrTextAv>
                <XrTextAv tag='p' variant='body'>
                  {authorizedUser.role_detail.role_name}
                </XrTextAv>

                <br />
                <XrTextAv tag='p' variant='description'>
                  Nama Peminjam
                </XrTextAv>
                <XrTextAv tag='p' variant='body'>
                  {props.form.issuer_name}
                </XrTextAv>

                <br />
                <XrTextAv tag='p' variant='description'>
                  Nomor Telepon Peminjam
                </XrTextAv>
                <XrTextAv tag='p' variant='body'>
                  {'-'}
                </XrTextAv>

                <br />
                <XrTextAv tag='p' variant='description'>
                  Organisasi Peminjam
                </XrTextAv>
                <XrTextAv tag='p' variant='body'>
                  {'-'}
                </XrTextAv>
              </div>
            </div>
          </BootstrapGrid>

          <br/>
          <XrTextAv tag='p' variant='description' spaceBottom='5'>
            Ruangan yang Ingin Dipinjam
          </XrTextAv>
          <XrDataTable style={{ marginTop: 0, marginBottom: '20px' }}>
            <div className="tablewrapper--table">
              <table>
                <thead>
                  <tr>
                    <th>Nama</th>
                    <th>Kapasitas</th>
                  </tr>
                </thead>
                <tbody>
                  {props.form.rooms.map(room => {
                    return (
                      <tr>
                        <td>{room.room_detail?.room_name}</td>
                        <td>10 orang</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </XrDataTable>

          <br/>
          <XrTextAv tag='p' variant='description' spaceBottom='5'>
            Inventaris yang Ingin Dipinjam
          </XrTextAv>
          <XrDataTable style={{ marginTop: 0, marginBottom: '20px' }}>
            <div className="tablewrapper--table">
              <table>
                <thead>
                  <tr>
                    <th>Nama</th>
                    <th>Jumlah</th>
                  </tr>
                </thead>
                <tbody>
                  {props.form.inventories.map(inventory => {
                    return (
                      <tr>
                        <td>{inventory.inventory_detail?.item_name}</td>
                        <td>{inventory.quantity}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </XrDataTable>

          <br/><br/>
          <div>
            <p>Setelah diajukan, peminjaman harus disetujui terlebih dahulu oleh tim PGDP. Ruangan dan inventaris akan diberikan sesuai dengan ketersediaan.</p>

            <br/>
            <XrButtonAv
              noBlock
              size='large'
              color='primary'
              caption={`Ajukan Peminjaman`}
              disabled={props.isLoading}
              isLoading={props.isLoading}
              onClick={() => props.confirmBooking()}
            />
          </div>
        </div>
      </XrCardAv>
    </React.Fragment>
  );
}

export default FormConfirm;